import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { CardHeader, cardStyle, DateRow, getCardBorderTop, TextRow, StatusRow } from 'components';
import { Images, PermissionList, RolePermission, useModal } from 'utils';
import { serviceSingleStyles } from './styles';
import { ClientDetails } from '../../clientModals/clientDetails';
import { CardItem } from '../../../../components/card/cardItem';

export const ClientGeneralInfo = ({}) => {
    const cardClasses = cardStyle();
    const classes = serviceSingleStyles();
    const borderTop = getCardBorderTop('General Info');
    const { open } = useModal();
    const data = useSelector((state) => state.client.clientItemInfo);

    return (
        <div className={cardClasses.card} style={{ width: '32.5%', maxWidth: '510px' || 210, height: 'auto', minHeight: '430px' }}>
            <>
                <div className={cardClasses.headerBorder} style={{ borderTop }} />
                <div className={classes.spaceBetween}>
                    <CardHeader color={'#347AF0'} title={'General Info'} icon={Images.generalInfoIcon} />
                    {RolePermission([PermissionList.CLIENT_CREATE?.code]) && (
                        <button
                            id="staff-general-edit-btn"
                            onClick={() => open(<ClientDetails info={data} />)}
                            className={classes.addButton}>
                            <img src={Images.edit} alt="icon" />
                        </button>
                    )}
                </div>
            </>
            <div>
                <CardItem title={'Rendering Provider'} value={data?.renderingProviderName ? data.renderingProviderName : 'Not Set'} />
                <CardItem title={'Supervising Provider'} value={data?.supervisingProviderName ? data.supervisingProviderName : 'Not Set'} />
                {data?.company && <CardItem title={'Home Office'} value={data?.company?.name ? data.company.name : 'Not Set'} />}
                {data?.phoneSecondary && (
                    <CardItem
                        title={'Secondary Phone Number'}
                        value={
                            data?.phoneSecondary
                                ? '(' +
                                  data?.phoneSecondary?.substr(0, 3) +
                                  ') ' +
                                  data?.phoneSecondary?.substr(3, 3) +
                                  '-' +
                                  data?.phoneSecondary?.substr(6, 6)
                                : ''
                        }
                    />
                )}
                <div className={classes.statusWrapper}>
                    <Box className={cardClasses.cardItem} style={{ padding: 0, marginBottom: 0 }}>
                        <div className={cardClasses.cardItemContainerStyle} style={{ alignItems: 'center' }}>
                            <p className={classes.rowTitle} style={{ whiteSpace: 'nowrap', marginRight: '6px' }}>
                                Status:
                            </p>
                            <StatusRow status={data?.status} />
                        </div>
                    </Box>
                    {data?.statusDate && (
                        <Box className={cardClasses.cardItem} style={{ padding: 0, marginBottom: 0 }}>
                            <div className={cardClasses.cardItemContainerStyle}>
                                <p className={classes.rowTitle} style={{ whiteSpace: 'nowrap' }}>
                                    Status Date:
                                </p>
                                <span style={{ width: '100%', marginTop: '2px' }} className={cardClasses.cardValue}>
                                    <DateRow date={data?.statusDate} />
                                </span>
                            </div>
                        </Box>
                    )}
                    {data?.statusReason && (
                        <Box className={cardClasses.cardItem} style={{ padding: 0, marginBottom: 0 }}>
                            <div className={cardClasses.cardItemContainerStyle}>
                                <p className={classes.rowTitle} style={{ whiteSpace: 'nowrap' }}>
                                    Reason:
                                </p>
                                <span style={{ width: '100%', marginTop: '2px' }} className={cardClasses.cardValue}>
                                    <TextRow name={data?.statusReason} />
                                </span>
                            </div>
                        </Box>
                    )}
                </div>
            </div>
        </div>
    );
};
